// #2121-spec-kits
import React from 'react';
import { Badge } from 'reactstrap';
import { translate } from 'react-translate';
import { useDroppable } from '@dnd-kit/core';

const ASSET_ICON = {
  cellphone:  'now-ui-icons tech_mobile',
  device:     'now-ui-icons objects_diamond',
  'sim card': 'now-ui-icons tech_tv',
};

const Droppable = ({ children }) => {
  const { isOver, setNodeRef } = useDroppable({ id: 'droppable' });
  return (
    <div
      ref={setNodeRef}
      className={`droppable-zone ${isOver ? 'is-over' : ''}`}
    >
      {children}
    </div>
  );
};

const ReservedAssetList = (props) => {
  const { t, unreserveAsset, reservedAssets } = props;
  const count = reservedAssets ? reservedAssets.length : 0;

  return (
    <div className="kit-dnd-col">
      <div className="kit-form-card-header">
        <i className="now-ui-icons ui-1_check" />
        <span>{t('reserved-assets')}</span>
        <Badge className="kit-form-card-count" pill>{count}</Badge>
      </div>

      <Droppable>
        {!count ? (
          <div className="droppable-empty">
            <div className="droppable-empty-icon">
              <i className="now-ui-icons arrows-1_share-66" />
            </div>
            <div className="droppable-empty-title">
              {t('drop-here-title') || 'Drop assets here'}
            </div>
            <div className="droppable-empty-hint">
              {t('drop-here-hint') || 'Drag from the left to reserve'}
            </div>
          </div>
        ) : (
          reservedAssets.map((as) => {
            const icon = ASSET_ICON[as.asset_type] || 'now-ui-icons objects_diamond';
            return (
              <div
                key={`as-${as._id}`}
                onClick={() => unreserveAsset(as._id)}
                className="assigned-asset"
                title={t('remove-asset') || 'Click to remove'}
              >
                <div className={`asset-icon ${icon}`} />
                <div className="asset-body">
                  <div className="asset-type">{as.asset_type || '—'}</div>
                  <div className="asset-meta">
                    {as.brand && <>{as.brand} · </>}
                    {as.serial_number || as._id}
                  </div>
                </div>
                <i className="remove-asset-icon now-ui-icons ui-1_simple-remove" />
              </div>
            );
          })
        )}
      </Droppable>
    </div>
  );
};

export default translate('kits')(ReservedAssetList);
